export default "__VITE_ASSET__6c40de9a__"